import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { GET } from "../../services/axios.service";
import { JobworkProps } from "../../types/jobwork";

export interface JobworkDetailsState {
  jobwork: JobworkProps;
  loading: boolean;
  error: string | null;
}

const initialState: JobworkDetailsState = {
  jobwork: {} as JobworkProps,
  loading: false,
  error: null,
};

export const fetchJobworkDetailsData = createAsyncThunk(
  "fetchJobworkDetailsData",
  async (req: { jobworkId: number }) => {
    let response: any;
    await GET(`/v1/worker/jobworks/${req.jobworkId}`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const jobworkDetailsSlice = createSlice({
  name: "jobworkDetails",
  initialState,
  reducers: {
    updateJobworkDetails: (state, action: PayloadAction<JobworkProps>) => {
      state.jobwork = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchJobworkDetailsData.pending, (state, action: any) => {
      state.jobwork = {} as JobworkProps;
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchJobworkDetailsData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.jobwork = action.payload.data.data;
        state.error = null;
      } else {
        state.jobwork = {} as JobworkProps;
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchJobworkDetailsData.rejected, (state, action: any) => {
      state.jobwork = {} as JobworkProps;
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { updateJobworkDetails } = jobworkDetailsSlice.actions;

export const getJobworkDetails = (state: RootState) =>
  state.jobworkDetails.jobwork;

export default jobworkDetailsSlice.reducer;
